import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { ForgotPasswordPage } from '../auth/forgot-password-page';
import { LoginPage } from '../auth/login-page';
import { UpdatePasswordPage } from '../auth/update-password-page';
import { EspaceProvider } from '../data/espace-context';
import { ApplicationShell } from '../shell/application-shell';
import { ProtectedRoute } from './protected-route';
import { PublicOnlyRoute } from './public-only-route';

/**
 * Chaque écran est chargé quand on y va. Le premier affichage ne descend plus
 * les six écrans, leurs dialogues et le glisser-déposer, mais la connexion
 * puis le seul Tableau. Les écrans publics restent dans le paquet de départ :
 * la page de connexion est la première chose que voit un navigateur vide.
 */
const TableauScreen = lazy(() =>
  import('../screens/tableau/TableauScreen').then((module) => ({
    default: module.TableauScreen,
  })),
);
const ADeciderScreen = lazy(() =>
  import('../screens/a-decider/ADeciderScreen').then((module) => ({
    default: module.ADeciderScreen,
  })),
);
const MaJourneeScreen = lazy(() =>
  import('../screens/ma-journee/MaJourneeScreen').then((module) => ({
    default: module.MaJourneeScreen,
  })),
);
const FilScreen = lazy(() =>
  import('../screens/fil/FilScreen').then((module) => ({ default: module.FilScreen })),
);
const AgendaScreen = lazy(() =>
  import('../screens/agenda/AgendaScreen').then((module) => ({ default: module.AgendaScreen })),
);
const PersonnesScreen = lazy(() =>
  import('../screens/personnes/PersonnesScreen').then((module) => ({
    default: module.PersonnesScreen,
  })),
);
const CompteScreen = lazy(() =>
  import('../screens/compte/CompteScreen').then((module) => ({ default: module.CompteScreen })),
);

/** Le temps de descendre un écran : un mot, jamais un écran vide. */
function Attente() {
  return <p className="tableau__attente">Chargement.</p>;
}

export function ApplicationRoutes() {
  return (
    <Routes>
      <Route
        path="/connexion"
        element={
          <PublicOnlyRoute>
            <LoginPage />
          </PublicOnlyRoute>
        }
      />
      <Route
        path="/mot-de-passe-oublie"
        element={
          <PublicOnlyRoute>
            <ForgotPasswordPage />
          </PublicOnlyRoute>
        }
      />
      <Route path="/nouveau-mot-de-passe" element={<UpdatePasswordPage />} />
      <Route
        element={
          <ProtectedRoute>
            <EspaceProvider>
              <Suspense fallback={<Attente />}>
                <ApplicationShell />
              </Suspense>
            </EspaceProvider>
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/tableau" replace />} />
        <Route path="/tableau" element={<TableauScreen />} />
        <Route path="/a-decider" element={<ADeciderScreen />} />
        <Route path="/ma-journee" element={<MaJourneeScreen />} />
        <Route path="/fil" element={<FilScreen />} />
        <Route path="/agenda" element={<AgendaScreen />} />
        <Route path="/personnes" element={<PersonnesScreen />} />
        <Route path="/compte" element={<CompteScreen />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
